import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentExceptionTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetItrackExceptionType`,
    method: 'get',
  });
};

export type ShipmentExceptionTypesResponse = {
  codeId: string;
  codeDesc: string;
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentExceptionTypes = async (): Promise<ShipmentExceptionTypesResponse> => {
  const response: AxiosResponse<ShipmentExceptionTypesResponse> = await getShipmentExceptionTypesAPI();
  return response.data;
};
